export function getGitCommit() {
    return process.env.GIT_COMMIT || 'DEV';
}
export function getBuildTime() {
    return process.env.BUILD_TIME;
}
export function getBuildTimestamp() {
    const overrideBuildTimestamp = getOverrideBuildTimestamp();
    if (overrideBuildTimestamp !== undefined) {
        return overrideBuildTimestamp;
    }
    const buildTimestamp = Number(process.env.BUILD_TIMESTAMP);
    if (!isNaN(buildTimestamp)) {
        return buildTimestamp;
    }
}
function getOverrideBuildTimestamp() {
    const params = new URLSearchParams(window.location.search);
    const overrideBuildTimestamp = params.get('overrideBuildTimestamp');
    return overrideBuildTimestamp != null ? Number(overrideBuildTimestamp) : undefined;
}
